import { Button } from "@cafe/ui";
import { CircleHelp } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";
import { articleForPath, helpContent } from "./content";

/** «?» в шапке: статья справочника про текущий раздел, иначе — главная справочника. */
export function HelpButton() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  // Разделы и пути одинаковы во всех языках — перевод для этого не нужен
  const id = pathname.startsWith("/help") ? null : articleForPath(helpContent("ru").content, pathname);
  const label = id ? t("help.aboutSection") : t("help.title");
  return (
    <Button variant="ghost" size="sm" className="size-9 px-0" asChild>
      <Link to={id ? `/help?a=${id}` : "/help"} aria-label={label} title={label}><CircleHelp className="size-5" aria-hidden /></Link>
    </Button>
  );
}
